import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SeoMeta from "../../components/SeoMeta";
import PageTitle from "./components/PageTitle";
import AllOfficina from "./components/AllOfficina";
import FooterOfficina from "./components/FooterOfficina";
import { useLoading } from "../../contexts/LoadingContext";

// Get locale from cookie
const getLocale = () => {
  const match = document.cookie.match(/(^|;)\s*locale=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : "en";
};

const Officina = () => {
  const { t } = useTranslation();
  const { setIsLoading } = useLoading();
  const [pageData, setPageData] = useState(null);
  const locale = getLocale();

  const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || "http://localhost:1337";
  const API_URL = `${STRAPI_URL}/api/portfolios?populate=*&locale=${locale}`;

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const res = await fetch(API_URL);
        const json = await res.json();
        setPageData(json.data);
      } catch (err) {
        console.error("❌ Error fetching Officina data:", err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [API_URL, setIsLoading]);

  if (!pageData) return null;

  return (
    <>
      <SeoMeta
        title="Officina Lussana"
        description={t("officina.SeoDescription")}
        keywords={t("officina.SeoKeywords")}
        robots="index, follow"
      />

      <section className="py-15 py-xl-20">
        <PageTitle />
        <AllOfficina data={pageData} />
        <FooterOfficina />
      </section>
    </>
  );
};

export default Officina;
